// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.link-body {
  padding-left: 24px;
}

.c-editable-form__item-li a {
  color: black;
  transition: color 0.2s;
}
.c-editable-form__item-li a:hover {
  color: #025EA1;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
